var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChartBar331X(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "77px",
    height: "77px",
    viewBox: "0 0 77 77",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "EAA1D9C0-B084-42B8-9EA0-6D0F4C7D354A@1x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.1-Dashboard-Default_Empty_state",
    transform: "translate(-792.000000, -291.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart-bar-33",
    transform: "translate(792.000000, 291.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.2,40 L31.8,40 C30.80595,40 30,40.8283375 30,41.85 L30,75.15 C30,76.1716625 30.80595,77 31.8,77 L46.2,77 C47.19405,77 48,76.1716625 48,75.15 L48,41.85 C48,40.8283375 47.19405,40 46.2,40 Z",
    id: "Path",
    fill: "#FF66AB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2,55 L1.8,55 C0.80595,55 0,55.820875 0,56.8333333 L0,75.1666667 C0,76.179125 0.80595,77 1.8,77 L16.2,77 C17.19405,77 18,76.179125 18,75.1666667 L18,56.8333333 C18,55.820875 17.19405,55 16.2,55 Z",
    id: "Path",
    fill: "#FFD200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,26 L60.8,26 C59.80595,26 59,26.8155446 59,27.8214286 L59,75.1785714 C59,76.1844554 59.80595,77 60.8,77 L75.2,77 C76.19405,77 77,76.1844554 77,75.1785714 L77,27.8214286 C77,26.8155446 76.19405,26 75.2,26 Z",
    id: "Path",
    fill: "#59D1FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7962173,28.7962217 L62.3333327,6.25911 L62.3333327,16.5 C62.3333327,17.5124583 63.1542079,18.3333333 64.1666664,18.3333333 C65.1791249,18.3333333 66,17.5124583 66,16.5 L66,1.83333333 C66,1.59454167 65.951215,1.35686833 65.8584483,1.13274333 C65.6725849,0.684585 65.3154149,0.327415 64.8672565,0.141551667 C64.6431314,0.048785 64.4054581,0 64.1666664,0 L49.5,0 C48.4875387,0 47.6666636,0.820875 47.6666636,1.83333333 C47.6666636,2.84579167 48.4875387,3.66666667 49.5,3.66666667 L59.740889,3.66666667 L38.5,24.9075567 L28.7962155,15.2037783 C28.0800787,14.4876417 26.9199085,14.4876417 26.2037717,15.2037783 L11.5371026,29.870445 C10.8209658,30.5865817 10.8209658,31.7467517 11.5371026,32.4628883 C11.895171,32.8209567 12.3642477,33 12.8333245,33 C13.3024012,33 13.771478,32.8209567 14.1295464,32.4628883 L27.5,19.0924433 L37.2037735,28.7962217 C37.9199103,29.5123767 39.0800805,29.5123767 39.7962173,28.7962217 Z",
    id: "Path",
    fill: "#BBBBBB"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBar331X);
export default __webpack_public_path__ + "static/media/chart-bar-33@1x.f6b8a1935cf8828915a3a1a7d99cb3a9.svg";
export { ForwardRef as ReactComponent };